app.service('orderUtils', function (loading, console, broker, ajaxOrder, front, orderConfig) {
	function send(action, ajax, focusParams) {
		var $form = $('#container form:eq(0)');

		$('#F_ACTION', $form).val(action);
		loading.start();
		requestAnimationFrame(function () {
			if (ajax) {
				broker.trigger('SUBMIT_BASKET_VIEW', focusParams);
			} else {
				if (testAB.getVar('ajax-order2') === 'B' && front.getParam('ajaxOrder')) {
					const config = orderConfig.getData();
					if (config.pageType == 'basket' && !config.isUserLogged && config.keycloakEnabled) {
						// w tym przypadku wiemy że napewno nie jesteśmy zalogowani, więc nie wysyłamy formularza, tylko przekierowujemy na logowanie w keycloak
						console.log('KOLEJNA STRONA TO KEYCLOAK, PRZEKIEROWANIE NA LOGOWANIE');
					} else {
						ajaxOrder.setForm($form);
					}
				} else {
					console.log('WYSŁANIE STANDARDOWEGO FORMULARZA');
				}
				$form.submit();
			}
		});
	}
	function back() {
		console.log('POWRÓT');
		ignore();
		send('BACK');
	}
	function ignore() {
		$('input, select, textarea').ignore(true);
	}
	return {
		send,
		back,
		ignore
	};
});
